(function ($) {
    $(function () {
        $('.js-match-height').matchHeight();

        if (Cookies.get("DONEGDPRAlertBoxClosed") != undefined) {
            $('body').addClass('alert-box--is-closed')
        }

        $('.hamburger, .nav-link-download').on('click', function(){
            $('.hamburger').toggleClass('is-active');
        });

        $('.nav-link-download').on('click', function(){
            $('.navbar-collapse').removeClass('show');
        });
    });
})(jQuery);

